import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Breadcrumbs from '../components/Breadcrumbs';

@connect(function ({ router }) {
  return { router };
})
export default class BreadcrumbsContainer extends Breadcrumbs {
  static propTypes = {
    currentPageTitle: PropTypes.string,
  };
}
